import React, {Component} from 'react';
import Intestazione from './components_novel/intestazione';
import Capitolo from './components/capitolo';
import Ebook from './components/ebook';
import Piedone from './components/piedone';
import Navbar from './components/navbar';
import Seo, {siteUrl} from './components/seo';

import logo from './images/Logo-Verso-Hemelslinn-2.webp';

import intestazioneBackgroundImage from './images/verso-hemelslinn-sfondo-2.webp';

import backgroundCapitoloImage1 from './images/sommario/00-preludio-02png.webp';
import backgroundCapitoloImage2 from './images/sommario/01-Prixian-02.webp';
import backgroundCapitoloImage3 from './images/sommario/02-la-rotta-si-apre-03.webp';
import backgroundCapitoloImage4 from './images/sommario/03-l-inseguimento-2.webp';
import backgroundCapitoloImage5 from './images/sommario/04-un-incontro-inatteso-03.webp';
import backgroundCapitoloImage6 from './images/sommario/05-lisier-02.webp';
import backgroundCapitoloImage7 from './images/sommario/06-naufraghi-02.webp';
import backgroundCapitoloImage8 from './images/sommario/07-il-primo-approdo-01.webp';
import backgroundCapitoloImage9 from './images/sommario/08-il-continente-di-ghiaccio-01.webp';
import backgroundCapitoloImage10 from './images/sommario/09-neve-e-fuoco-01.webp';
import backgroundCapitoloImage11 from './images/sommario/10-hemelslinn-01.webp';
import backgroundCapitoloImage12 from './images/sommario/11-oltre-la-missione-01.webp';
import backgroundCapitoloImage13 from './images/sommario/12-la-soglia-02.webp';
import backgroundCapitoloImage14 from './images/sommario/13-il-vecchio-mondo-01.webp';
import backgroundCapitoloImage15 from './images/sommario/14-Il-peso-della-scelta-01.webp';
import backgroundCapitoloImage16 from './images/sommario/15-la-lunga-notte-01.webp';
import backgroundCapitoloImage17 from './images/sommario/16-caput-mundi-02.webp';
import backgroundCapitoloImage18 from './images/sommario/17-il-prezzo-del-ritorno-01.webp';
import backgroundCapitoloImage19 from './images/sommario/18-la-rotta-incompiuta-01.webp';
import backgroundCapitoloImage20 from './images/sommario/19-una-presenza-inattesa-01.webp';
import backgroundCapitoloImage21 from './images/sommario/20-tra-le-ombre-della-orion-galactic.webp';
import backgroundCapitoloImage22 from './images/sommario/21-uno-due-tanti-01.webp';
import backgroundCapitoloImage23 from './images/sommario/22-amore-e-pericolo-01.webp';
import backgroundCapitoloImage24 from './images/sommario/23-la-promessa-01.webp';
import backgroundCapitoloImage25 from './images/sommario/24-la-rivoluzione-01.webp';
import backgroundCapitoloImage26 from './images/sommario/25-ritorno-a-hemelslinn-01.webp';
import backgroundCapitoloImage27 from './images/sommario/26-cio-che-resta-aperto.webp';
import backgroundCapitoloImage28 from './images/sommario/27-epilogo-l-essenza.webp';
import backgroundEbookImage from './images/tablet-smartphon-verso-hemelslinn.webp';


const CapitoloStyle1 = {backgroundImage: `url(${backgroundCapitoloImage1})`,};
const CapitoloStyle2 = {backgroundImage: `url(${backgroundCapitoloImage2})`,};
const CapitoloStyle3 = {backgroundImage: `url(${backgroundCapitoloImage3})`,};
const CapitoloStyle4 = {backgroundImage: `url(${backgroundCapitoloImage4})`,};
const CapitoloStyle5 = {backgroundImage: `url(${backgroundCapitoloImage5})`,};
const CapitoloStyle6 = {backgroundImage: `url(${backgroundCapitoloImage6})`,};
const CapitoloStyle7 = {backgroundImage: `url(${backgroundCapitoloImage7})`,};
const CapitoloStyle8 = {backgroundImage: `url(${backgroundCapitoloImage8})`,};
const CapitoloStyle9 = {backgroundImage: `url(${backgroundCapitoloImage9})`,};
const CapitoloStyle10 = {backgroundImage: `url(${backgroundCapitoloImage10})`,};
const CapitoloStyle11 = {backgroundImage: `url(${backgroundCapitoloImage11})`,};
const CapitoloStyle12 = {backgroundImage: `url(${backgroundCapitoloImage12})`,};
const CapitoloStyle13 = {backgroundImage: `url(${backgroundCapitoloImage13})`,};
const CapitoloStyle14 = {backgroundImage: `url(${backgroundCapitoloImage14})`,};
const CapitoloStyle15 = {backgroundImage: `url(${backgroundCapitoloImage15})`,};
const CapitoloStyle16 = {backgroundImage: `url(${backgroundCapitoloImage16})`,};
const CapitoloStyle17 = {backgroundImage: `url(${backgroundCapitoloImage17})`,};
const CapitoloStyle18 = {backgroundImage: `url(${backgroundCapitoloImage18})`,};
const CapitoloStyle19 = {backgroundImage: `url(${backgroundCapitoloImage19})`,};
const CapitoloStyle20 = {backgroundImage: `url(${backgroundCapitoloImage20})`,};
const CapitoloStyle21 = {backgroundImage: `url(${backgroundCapitoloImage21})`,};
const CapitoloStyle22 = {backgroundImage: `url(${backgroundCapitoloImage22})`,};
const CapitoloStyle23 = {backgroundImage: `url(${backgroundCapitoloImage23})`,};
const CapitoloStyle24 = {backgroundImage: `url(${backgroundCapitoloImage24})`,};
const CapitoloStyle25 = {backgroundImage: `url(${backgroundCapitoloImage25})`,};
const CapitoloStyle26 = {backgroundImage: `url(${backgroundCapitoloImage26})`,};
const CapitoloStyle27 = {backgroundImage: `url(${backgroundCapitoloImage27})`,};
const CapitoloStyle28 = {backgroundImage: `url(${backgroundCapitoloImage28})`,};

const intestazioneBackgroundStyle = {backgroundImage: `url(${intestazioneBackgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center center', backgroundAttachment: 'fixed', height: '300px'};

const EbookStyle = {backgroundImage: `url(${backgroundEbookImage})`,};

// Create the function
export function AddLibrary(urlOfTheLibrary) {
  const script = document.createElement('script');
  script.src = urlOfTheLibrary.startsWith('/') ? urlOfTheLibrary : '/' + urlOfTheLibrary;
  script.async = true;
  document.body.appendChild(script);
}


class Sommario extends Component {
  state = {
    Capitoli: [
		{id: 0, capitoloStile: CapitoloStyle1, capitoloTitolo: "Preludio", capitoloDescrizione: "Un bagliore impossibile apre una storia destinata a spostare ogni rotta."},
		{id: 1, capitoloStile: CapitoloStyle2, capitoloTitolo: "Prixian", capitoloDescrizione: "Una società ordinata, un equipaggio pronto, e una missione che comincia molto prima della partenza."},
		{id: 2, capitoloStile: CapitoloStyle3, capitoloTitolo: "La rotta si apre", capitoloDescrizione: "La Delphís lascia ciò che conosce e si inoltra in un viaggio dove ogni incontro può cambiare il destino."},
		{id: 3, capitoloStile: CapitoloStyle4, capitoloTitolo: "L’inseguimento", capitoloDescrizione: "Quando la libertà diventa una corsa, ogni scelta a bordo può decidere la salvezza."},
		{id: 4, capitoloStile: CapitoloStyle5, capitoloTitolo: "Un incontro inatteso", capitoloDescrizione: "Tra pericolo e diffidenza, una presenza inattesa può trasformare una fuga in una possibilità."},
		{id: 5, capitoloStile: CapitoloStyle6, capitoloTitolo: "Lisier", capitoloDescrizione: "Davanti a una luce immensa, la Delphís affronta il limite sottile tra meraviglia e rischio."},
		{id: 6, capitoloStile: CapitoloStyle7, capitoloTitolo: "Naufraghi", capitoloDescrizione: "Nel silenzio di una quiete luminosa, la Delphís vaga senza rotta, sospesa tra smarrimento e speranza."},
		{id: 7, capitoloStile: CapitoloStyle8, capitoloTitolo: "Il primo approdo", capitoloDescrizione: "Un mondo sconosciuto si apre davanti all’equipaggio: ogni passo può essere scoperta, pericolo o promessa."},
		{id: 8, capitoloStile: CapitoloStyle9, capitoloTitolo: "Il continente di ghiaccio", capitoloDescrizione: "Tra distese di ghiaccio e orizzonti ostili, il viaggio diventa prova di resistenza, fiducia e coraggio."},
		{id: 9, capitoloStile: CapitoloStyle10, capitoloTitolo: "Neve e fuoco", capitoloDescrizione: "Nel cuore del gelo, lo scontro mette alla prova non solo la sopravvivenza, ma ciò che ciascuno è disposto a proteggere."},
		{id: 10, capitoloStile: CapitoloStyle11, capitoloTitolo: "Hemelslinn", capitoloDescrizione: "Un nome atteso, un mondo da comprendere, una cultura capace di interrogare ogni certezza."},
		{id: 11, capitoloStile: CapitoloStyle12, capitoloTitolo: "Oltre la missione", capitoloDescrizione: "Quando il dovere non basta più a spiegare la rotta, i sentimenti diventano parte del viaggio."},
		{id: 12, capitoloStile: CapitoloStyle13, capitoloTitolo: "La soglia", capitoloDescrizione: "Una rivelazione si avvicina senza fare rumore, e ciò che sembrava chiaro comincia a cambiare forma."},
		{id: 13, capitoloStile: CapitoloStyle14, capitoloTitolo: "Il vecchio mondo", capitoloDescrizione: "Tra memorie, regole e contraddizioni, Hemelslinn mostra un volto più complesso di quanto l’equipaggio immaginasse."},
		{id: 14, capitoloStile: CapitoloStyle15, capitoloTitolo: "Il peso della scelta", capitoloDescrizione: "Una decisione impossibile costringe a misurare il confine tra fedeltà, paura e ciò che davvero conta."},
		{id: 15, capitoloStile: CapitoloStyle16, capitoloTitolo: "La lunga notte", capitoloDescrizione: "Nell’oscurità più estesa, il gruppo scopre quanto fragile, e quanto necessaria, possa essere la fiducia."},
		{id: 16, capitoloStile: CapitoloStyle17, capitoloTitolo: "Caput Mundi", capitoloDescrizione: "Tra grandezza e rovina, un luogo carico di memoria costringe a guardare ciò che resta quando una civiltà si consuma."},
		{id: 17, capitoloStile: CapitoloStyle18, capitoloTitolo: "Il prezzo del ritorno", capitoloDescrizione: "Quando ogni ritorno ha un prezzo, scegliere una rotta significa anche capire chi si è diventati."},
		{id: 18, capitoloStile: CapitoloStyle19, capitoloTitolo: "La rotta incompiuta", capitoloDescrizione: "Una nuova fase si apre tra ciò che è stato lasciato indietro e ciò che ancora attende di essere compiuto."},
		{id: 19, capitoloStile: CapitoloStyle20, capitoloTitolo: "Una presenza inattesa", capitoloDescrizione: "Dalla distanza emerge una figura enigmatica, portando con sé domande che nessuno può ignorare."},
		{id: 20, capitoloStile: CapitoloStyle21, capitoloTitolo: "Tra le ombre della Orion Galactic", capitoloDescrizione: "Quando la minaccia si fa più vicina, il coraggio diventa una scelta concreta, non un’idea."},
		{id: 21, capitoloStile: CapitoloStyle22, capitoloTitolo: "Uno, due, tanti", capitoloDescrizione: "Ogni preparativo apre una crepa nell’ordine stabilito; ciò che inizia come un piano può diventare qualcosa di molto più grande."},
		{id: 22, capitoloStile: CapitoloStyle23, capitoloTitolo: "Amore e pericolo", capitoloDescrizione: "Nel punto in cui paura e desiderio si sfiorano, anche il pericolo può rivelare ciò che era rimasto nascosto."},
		{id: 23, capitoloStile: CapitoloStyle24, capitoloTitolo: "La promessa", capitoloDescrizione: "Una presenza inattesa porta luce in mezzo alle incertezze, ricordando che ogni viaggio lascia tracce vive."},
		{id: 24, capitoloStile: CapitoloStyle25, capitoloTitolo: "La rivoluzione", capitoloDescrizione: "La quiete della galassia vacilla: ciò che era preparazione diventa scelta, azione, cambiamento."},
		{id: 25, capitoloStile: CapitoloStyle26, capitoloTitolo: "Ritorno a Hemelslinn", capitoloDescrizione: "Un luogo già conosciuto non è mai lo stesso, quando a cambiare sono gli occhi di chi vi ritorna."},
		{id: 26, capitoloStile: CapitoloStyle27, capitoloTitolo: "Ciò che resta aperto", capitoloDescrizione: "Quando una missione lascia domande senza risposta, il cuore deve trovare un modo per non restare prigioniero del rimpianto."},
		{id: 27, capitoloStile: CapitoloStyle28, capitoloTitolo: "Epilogo — L’essenza", capitoloDescrizione: "Dopo ogni rotta, resta ciò che ha dato senso al viaggio: le scelte, i legami, l’essenza di chi ha attraversato le stelle."}
    ],
	aNavbarLinks: [
		{id: 0, linkHref: "/", linkNome: "ROMANZO"},
	],
  }



  render() {
    const summaryJsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/summary#webpage`,
          url: `${siteUrl}/summary`,
          name: 'Sommario e capitoli di Verso Hemelslinn',
          description:
            'Sommario narrativo di Verso Hemelslinn, con capitoli, Delphís, equipaggio e rotte della storia.',
          isPartOf: {
            '@id': `${siteUrl}/#website`,
          },
          about: {
            '@id': `${siteUrl}/#book`,
          },
          inLanguage: 'it-IT',
        },
        {
          '@type': 'BreadcrumbList',
          '@id': `${siteUrl}/summary#breadcrumb`,
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'Verso Hemelslinn',
              item: `${siteUrl}/`,
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'Sommario',
              item: `${siteUrl}/summary`,
            },
          ],
        },
      ],
    };

    return (
      <>
        <div className="page">
		    <Seo
				title="Sommario e capitoli"
				description="Scopri il sommario di Verso Hemelslinn: i primi capitoli, la Delphís, l’equipaggio e le rotte narrative di una space opera romantica senza alieni."
				path="/summary"
				image="/images/copertina-verso-hemelslinn.webp"
				jsonLd={summaryJsonLd}
			/>
		    <Navbar 
				linkSito='/'
				logo={logo}
				deskLogo='Logo di Verso Hemelslinn'
				brandName='Verso Hemelslinn'
				aNavbarLinks = {this.state.aNavbarLinks}
			/>	
          <div id="pagina">
			<Intestazione
              pagina="SOMMARIO"
              backgroundStyle={intestazioneBackgroundStyle}
              titolo="VERSO HEMELSLINN"
              titoloAs="p"
              romanzo="un romanzo di"
              autore="MAURIZIO FERUGLIO"
            />

			<section className="ftco-section ftco-no-pb">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-md-10 ftco-animate">
							<div className="heading-section text-center mb-5">
							<h1>Sommario e capitoli di Verso Hemelslinn</h1>
							<p>Scorri i capitoli di Verso Hemelslinn e scopri l'avventura!</p>
							</div>
						</div>
					</div>
				</div>
				<div className="container-fluid px-4">
					<div className="row d-flex">
						{this.state.Capitoli.map(capitolo => (
						<Capitolo
							key={capitolo.id}
							sectioncapitolo={capitolo} />
						))}
						
					</div>
				</div>
			</section>


            <Ebook
              ebookStile={EbookStyle}
              ebookTitle="VERSO HEMELSLINN ebook ePub"
              ebookTagLine="Leggilo anche in ebook su tutti i dispositivi!"
              ebookElenco='<li><span class="ion-ios-checkmark-circle mr-2"></span> <em>Accessibile</em> per non vedenti e ipovedenti, in formato epub3.</li>
              <li><span class="ion-ios-checkmark-circle mr-2"></span> Altri formati disponibili: Kindle, Mobi e PDF.</li>
              <li><span class="ion-ios-checkmark-circle mr-2"></span> Puoi leggerlo con uno screen reader o un lettore braille.</li>
              <li><span class="ion-ios-checkmark-circle mr-2"></span> Puoi leggerlo con Kindle, Kobo e altri eReader</li>
              <li><span class="ion-ios-checkmark-circle mr-2"></span> Puoi leggerlo su tablet, smartphone o PC.</li>'
              ebookInfoAccessibilita="Per saperne di più sull'accessibilità, leggi:"
              ebookLinkAccessibilita="https://www.eliosfera.it/ebook-con-contenuti-accessibili-eliosfera-editrice"
              ebookTitleLink="Link all'articolo Ebook con contenuti accessibili."
              ebookDescAccessibilita="Ebook con contenuti accessibili"
              ebookCallAction="Allora, cosa stai aspettando? L'avventura ti aspetta anche in digitale!"
              ebookLink="https://hemelslinn.s.gy/vh-web-hem-sommario"
              ebookButton="INIZIA IL VIAGGIO!"
            />


            <section className="ftco-section seo-pillar-section">
              <div className="container">
                <article className="seo-pillar-shell">
                  <h2>Domande frequenti</h2>
                  <div className="seo-pillar-faq">
                    <details open>
                      <summary>Il sommario contiene spoiler?</summary>
                      <p>No. Presenta le tappe principali del viaggio senza sostituire la lettura del romanzo e senza anticipare i passaggi decisivi.</p>
                    </details>
                    <details>
                      <summary>Da dove posso proseguire?</summary>
                      <p>Puoi leggere gli <a href="/articoli">articoli del laboratorio narrativo</a> o scoprire <a href="/cos-e-verso-hemelslinn/">cos'e Verso Hemelslinn</a>.</p>
                    </details>
                    <details>
                      <summary>Dove posso seguire la pubblicazione?</summary>
                      <p>Puoi seguire la <a href="https://hemelslinn.s.gy/vh-web-hem-land">campagna crowdfunding</a> dedicata al progetto editoriale.</p>
                    </details>
                  </div>
                </article>
              </div>
            </section>


			<Piedone
				piedoneCallToAction='Ogni rotta comincia da una scelta. Qui puoi scoprire da dove parte la Delphís.'
				piedoneLinkTermConditions=''
				piedoneLinkCookies='/cookies'
				piedoneLinkPrivacy='/privacy'			
				piedoneIframe=''
				piedoneTwitter='https://x.com/VersoHemelslin'
				piedoneInstagram='https://www.instagram.com/versohemelslinn/'
				piedoneFacebook='https://www.facebook.com/eliosfera'
				piedoneDiscord=''
				piedonePinterest='https://it.pinterest.com/hemelslinn/'
				piedoneOpensea=''
				piedoneEliosfera='https://www.eliosfera.it/maurizio-feruglio-verso-hemelslinn-copertina-rigida-libro'
				piedoneYoutube='https://www.youtube.com/@VersoHemelslinn'
				piedoneCopyright="Eliosfera Editrice &copy;"
				piedoneCopyrightDisclaimer="Tutti i diritti riservati"
				piedoneCCBY='Template basato su <i class="icon-heart" aria-hidden="true"></i> <a href="https://colorlib.com" target="_blank">Colorlib</a>'
			/>


          </div>

          {AddLibrary(
            'js/aos.js')}
          {AddLibrary(
            'js/jquery.animateNumber.min.js')}
          {AddLibrary(
            'js/jquery.mb.YTPlayer.min.js')}
          {AddLibrary(
            'js/jquery.min.js')}
          {AddLibrary(
            'js/jquery.stellar.min.js')}
          {AddLibrary(
            'js/jquery.waypoints.min.js')}
          {AddLibrary(
            'js/jquery-migrate-3.0.1.min.js')}
          {AddLibrary(
            'js/owl.carousel.min.js')}
          {AddLibrary(
            'js/scrollax.min.js')}
          {AddLibrary(
            'js/main.js')}
        </div>
      </>
    );
  }
}

export default Sommario;
